// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21XXF","newExpiryDate":"styles_newExpiryDate__22UPC","footer":"styles_footer__30-56"};